import { call, takeEvery } from 'redux-saga/effects';
import listener from '@/layout/goldenLayoutListener';
import { searchUrl } from '@/constants/urls';
import actions from '../constants';

export function* closeTab({ destroy, code }) {
  if (destroy) {
    yield call(listener.closeTab, [searchUrl({ code })]);
  }
}

export default function* searchSharingLayout() {
  yield takeEvery(actions.SHARE_SEARCH_SUCCESS, closeTab);
}
